import React, { useState } from 'react';
import {
    Grid,
    Button,
    Paper,
    Typography,
    Link,
    InputLabel,
    FormControl,
    Select
} from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { setSelectedClaim, setClaimDate } from "../../application/actions";
import { useAppState } from "../../application/AppState";
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import { validateClaimDate } from "../../application/api";
import useTranslation from "../../application/translation";

const ClaimSelect = () => {
    const [{ insurances }, dispatch] = useAppState();
    const [claimDateLocal, setClaimDateLocal] = useState(null);
    const [claimType, setClaimType] = useState(0);
    const [missingInsurance, setMissingInsurance] = useState(false);
    const translation = useTranslation();

    const showUnemployment = () => {
        return (insurances && insurances.length === 1 && insurances[0].policyType == 'PPI Basic') === false;
    };

    const datePickerTheme = createMuiTheme({
        overrides: {
        MuiPickersCalendarHeader: {
        dayLabel: {
        color: '#000000',            
        fontWeight: 600,           
        }
     }
    }
    });


    const openFormClick = async () => {
        const result = await validateClaimDate(claimDateLocal);
        dispatch({ type: "resetForms" });
        if (result) {
            if (result.hasInsurance === true) {
                dispatch(setSelectedClaim(claimType));
                dispatch(setClaimDate(claimDateLocal));
            } else {
                setMissingInsurance(true);
            }
        }
    };

    const getMissingInsuranceText = (missing) => {
        if (!missing) return "";
        return (
            <Typography variant="body2">
                {translation.ins_notfound1}<br />
                {translation.ins_notfound2}<br />
                <Link href={`mailto:${translation.startpage_email}`}>
                    E-post: {translation.startpage_email}
                </Link><br />
                {translation.ins_notfound3}
            </Typography>
        );
    };

    const handleClaimDateChange = (date) => {
        setClaimDateLocal(date);
    };

        const handleClaimTypeChange = (event) => {
            setClaimType(Number(event.target.value));
          };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Paper elevation={3} style={{ padding: '5px' }}>
                    <Typography variant="body2">
                        {translation.claim_info1_1}<br />
                        {translation.claim_info1_2}<br />
                        {translation.claim_info1_3}<br />
                    </Typography>
                    <br />
                    <Typography variant="body2">
                        {translation.claim_info2_1}<br /><br />
                        <b>{translation.claim_info2_2}</b>
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={6} sm={5} md={4} lg={3}>
                <FormControl margin="normal" variant="outlined" fullWidth>
                    <InputLabel htmlFor="claim-type-select">
                        {translation.claim_event}
                    </InputLabel>
                    <Select
                        native
                        value={claimType}
                        onChange={handleClaimTypeChange}
                        label={translation.claim_event}
                        inputProps={{
                            name: 'claimType',
                            id: 'claim-type-select',
                            'aria-label': translation.claim_event
                        }}
                    >
                        <option value="0" disabled>
                            {translation.claim_event_placeholder}
                        </option>
                        {showUnemployment() && (
                            <option value={1}>{translation.claim_unemployment}</option>
                        )}
                        <option value={2}>{translation.claim_sick}</option>
                        <option value={3}>{translation.claim_hospital}</option>
                    </Select>
                </FormControl>
            </Grid>

            {/* —————————————— Lägg in här —————————————— */}

         



            <Grid item xs={12} sm={6} md={3} lg={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                 <ThemeProvider theme={datePickerTheme}>
                 <KeyboardDatePicker
                        id="claimDate"
                        name="claimDate"
                        label={translation.claim_date}
                        format={translation.dateformat}
                        margin="normal"
                        inputVariant="outlined"
                        value={claimDateLocal}
                        onChange={handleClaimDateChange}
                        KeyboardButtonProps={{
                            'aria-label': translation.claim_date
                        }}
                        InputProps={{
                            'aria-label': translation.claim_date
                            }}
                        leftArrowButtonProps={{ 'aria-label': 'Föregående månad' }}
                        rightArrowButtonProps={{ 'aria-label': 'Nästa månad' }}
                        />
                        </ThemeProvider>
                </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12}>
                <Typography display="inline" color="error" variant="body2">
                    <b>
                        {claimType === 1 ? translation.claim_unemployment_info : ""}
                        {claimType === 2 ? translation.claim_sick_info : ""}
                        {claimType === 3 ? translation.claim_hospital_info : ""}
                    </b>
                </Typography>
                <Typography display="inline" variant="body2">
                    {claimType === 1 ? translation.claim_unemployment_info2 : ""}
                    {claimType === 2 ? translation.claim_sick_info2 : ""}
                    {claimType === 3 ? translation.claim_hospital_info2 : ""}
                </Typography>
            </Grid>

            <Grid item xs={12}>
               <Button
                    variant="contained"
                    color="primary"
                    disabled={claimDateLocal === null || claimType === 0}
                    onClick={openFormClick}
                    type="submit"
                    aria-label={translation.claim_button}
                    style={{ color: theme => theme.palette.primary.contrastText }}
                >
                    {translation.claim_button}
                </Button>
            </Grid>

            <Grid item xs={12}>
                {getMissingInsuranceText(missingInsurance)}
            </Grid>
        </Grid>
    );
};

export default ClaimSelect;
